import { Button, StackLayout } from "@salt-ds/core";
import { ArrowLeftIcon } from "@salt-ds/icons";
import { StepLabel, SteppedTracker, TrackerStep } from "@salt-ds/lab";
import { SetStateAction } from "react";

type StepState = "completed" | "default";

type StepTrackerParams = {
  activeStep: number;
  stepStatusArray: StepState[];
  stepNames: string[];
};

export const StepTracker: React.FC<StepTrackerParams> = ({
  activeStep,
  stepNames,
  stepStatusArray,
}) => {
  return (
    <StackLayout
      direction="column"
      className="pb-6 pt-1"
      style={{ width: "100%", margin: "auto" }}
    >
      <SteppedTracker activeStep={activeStep}>
        {stepNames &&
          stepNames.length > 0 &&
          stepNames.map((step, index) => (
            <TrackerStep key={step} state={stepStatusArray[index] || "default"}>
              <StepLabel>{step}</StepLabel>
            </TrackerStep>
          ))}
      </SteppedTracker>
    </StackLayout>
  );
};

type StepTrackerPrevNextBtnsProps = {
  nextBtn: string;
  backBtn?: string;
  handleSubmit: () => void;
  handleBack?: () => void;
  nextBtnActive: any;
  setNextBtnActive: React.Dispatch<SetStateAction<boolean>>;
};

export const StepTrackerPrevNextBtns = ({
  ...props
}: StepTrackerPrevNextBtnsProps) => {
  return (
    <div className="pb-6 inline-flex">
      {props.backBtn !== "" && (
        <Button
          variant="secondary"
          className="text-customBlue hover:text-customBlue normal-case rounded-md mr-4"
          onClick={props.handleBack}
        >
          <ArrowLeftIcon /> {props.backBtn}
        </Button>
      )}
      {!props.nextBtnActive ? (
        <Button
          variant="primary"
          className="normal-case rounded-md mr-4"
          disabled
          onClick={props.handleSubmit}
        >
          {props.nextBtn}
        </Button>
      ) : (
        <Button
          variant="cta"
          className="normal-case rounded-md mr-4"
          onClick={props.handleSubmit}
        >
          {props.nextBtn}
        </Button>
      )}
    </div>
  );
};
